import { ContentType } from '@insided/shared/utils/contentType'
import { Author } from '../interfaces'
import Approve from './Approve'

import Button from '@insided/control/uikit/Button'
/* eslint-disable import/no-internal-modules */
import EscalationOptions from '../Escalation/EscalationOptions'
import { MoveToTopic } from '../MoveToTopic'
import { ConfigContext } from '../utils'

export interface PostActionsProps {
  topicId: number
  contentType: ContentType
  author: Author
  title: string
  content: string | null
  trashed: boolean
  pending: boolean
  destinationUrl: string
  userId?: string
  isProductboardNoteCreationEnabled: boolean
  isSalesforceCaseEscalationEnabled: boolean
  isZendeskTicketEscalationEnabled: boolean
  isFreshdeskTicketEscalationEnabled: boolean
  onShowEditor: () => void
  onApprove: () => void
  onShowAlert: (type: 'success' | 'error', message?: string) => void
  publicId?: string
  visibleReplyCount?: number | null
}

const OpeningPostActions = ({ title, userId, content, onShowEditor, onApprove, onShowAlert, destinationUrl, author, topicId, contentType, trashed, isProductboardNoteCreationEnabled, isSalesforceCaseEscalationEnabled, isZendeskTicketEscalationEnabled, isFreshdeskTicketEscalationEnabled, pending, publicId, visibleReplyCount }: PostActionsProps) => {
  return (
    <ConfigContext.Consumer>
      {({ contentTypeConfig }) => {
        return (
          <div className='post__panel-footer--action-box js-post-panel-footer-action-box'>
            <div className='post__panel-footer--action-box_actions'>
              <Button
                title='Edit post'
                variant='secondary'
                onClick={onShowEditor}
                data-qa='edit-post'
              />
              <EscalationOptions
                isZendeskTicketEscalationEnabled={isZendeskTicketEscalationEnabled}
                isProductboardNoteCreationEnabled={isProductboardNoteCreationEnabled}
                isSalesforceCaseEscalationEnabled={isSalesforceCaseEscalationEnabled}
                isFreshdeskTicketEscalationEnabled={isFreshdeskTicketEscalationEnabled}
                trashed={trashed}
                userId={author.id}
                username={author.username}
                publicId={topicId}
                moderatorId={userId as string}
                title={title}
                content={content}
                isReply={false}
                contentType={contentType}
                destinationUrl={destinationUrl}
                topicId={topicId}
              />

              {contentTypeConfig.moveTopicToExistingTopic && !trashed &&
                <MoveToTopic
                  contentType={contentType}
                  topicId={topicId}
                  onShowAlert={onShowAlert}
                  publicId={publicId}
                  visibleReplyCount={visibleReplyCount}
                />}

              {pending &&
                <Approve
                  topicId={topicId}
                  contentType={contentType}
                  onApprove={onApprove}
                  onShowAlert={onShowAlert}
                />}
            </div>
          </div>
        )
      }}
    </ConfigContext.Consumer>
  )
}

export default OpeningPostActions
